import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { LoadingItemDesktop } from '../LoadingItem/desktop';

export const LoadingDesktopTable: React.FC = () => {
  const loadingSize = { length: 10 };

  return (
    <VStack space={Spacing['inline.nano']}>
      {Array.from(loadingSize).map((_, index) => (
        <LoadingItemDesktop key={`customer-loading-item-${index}`} />
      ))}
    </VStack>
  );
};
